import { Component, OnInit } from '@angular/core'
import { SetupBarService } from '@se-po/shared-ui-setup-bar'

@Component({
  selector: 'se-po-minor-account-invite-sent',
  templateUrl: './minor-account-invite-sent.component.html',
  styleUrls: ['./minor-account-invite-sent.component.scss'],
  standalone: false,
})
export class MinorAccountInviteSentComponent implements OnInit {
  constructor(
    private setupService: SetupBarService,
  ) { }

  public ngOnInit(): void {
    this.setupService.percentComplete = 100
  }
}
